import { RQ } from 'utils';
import moment from 'dayjs';
const dateFormatStr = 'YYYY-MM-DD HH:mm:ss';

export default {
  async init () {
    console.log('=================创建全部评论');
    const materialId = this.$route.params.id;
    this.materialId = materialId;
    // this.hotCommentList = await this.getHotCommentList({materialId});
    await this.getHotCommentList({materialId});
    await this.getComment();
  },
  // 获取评论
  async getComment () {
    let self = this;
    let res = await RQ.mall.get('/api/h5/material/getCommentList', { materialId: this.materialId, page: this.page, pageSize: this.pageSize }, {enterprise: '', loading: false});
    if (res && res.code == 0) {
      console.log('=================最新评论',res);
      this.commentTotal = res.data.total;
      let commentNum = res.data.pageData.length;
      for (let i = 0; i < commentNum; i++) {
        this.commentData.push(res.data.pageData[i])
      }
      console.log('=================最新评论渲染数据',this.commentData);
    }
  },
  // 获取子评论
  async getCommentDetail () {
    let res = await RQ.mall.get('/api/h5/material/getCommentDetail', { materialId: this.materialId, materialCommentId: this.materialCommentId, page: this.page, pageSize: this.pageSize }, {enterprise: '', loading: false});
    if (res && res.code == 0) {
      console.log(res);
      this.commentData.push(res.data);
      if (!res.data.replyList) {
        this.commentTotal = 0;
        return
      }
      // let commentNum = res.data.replyListData.list.length;
      // this.commentTotal = res.data.replyListData.total;
      // for (let i = 0; i < commentNum; i++) {
      //   this.commentData.push(res.data.replyListData.list[i])
      // }
      this.commentTotal = res.data.replyList.length;
      console.log('================二级评论渲染数据',this.commentData);
    }
  },
  /**
   * 获取热评列表（无分页）
   * @params materialId
   * @returns {Promise.<*>}
   */
  async getHotCommentList (params) {
    const res = await RQ.mall.get('/api/h5/material/getHotCommentList', { ...params }, {enterprise: '', loading: false});
    if (res && res.code == 0) {
      // console.log('=================热门评论',res);
      this.hotCommentList = res;
      console.log('=================热门评论渲染数据',this.hotCommentList);
    }
  },
  /**
   * 点赞操作
   * 调用接口时，likeType字段、likeUser字段与isLiked字段是必须传递的，
   * 这样后端才知道点赞类型和是否点赞。如果是文章点赞，只需要materialId。
   * 如果是评论点赞，需要materialId和materialCommentId。
   * params: likeType,likeUser,materialId,materialCommentId,isLiked
   **/
  async handleLikeArticle (params) {
    let res = await RQ.mall.post('/api/h5/material/likeArticle', {
      ...params
    }, {jsonBody: false, enterprise: '', loading: false});
  },
  async sendComment () {
    let res = await RQ.mall.post('/api/h5/material/participateComment', {
      prevCommentId: this.materialCommentId || null,  // 接口不能传undifined
      firstCommentId: this.firstCommentId || null,
      commentType: this.commentType,
      commentContent: this.evaluation,
      materialId: this.materialId
     }, {jsonBody: false, enterprise: '', loading: false});
    if (res && res.code == 0) {
      return {...res.data};
    } else {
      throw res.msg;
    }
  },
  handleonLoad () {
    // 异步更新数据
    setTimeout(() => {
      this.page++;
      if (this.replyName) {
        // this.getCommentDetail()
      } else {
        this.getComment();
      }
      // 加载状态结束
      this.loading = false;

      // 数据全部加载完成
      if (this.pageSize * this.page >= this.commentTotal) {
        console.log('===========加载完成',this.commentTotal);
        this.finished = true;
      }
    }, 500);
  },
  handleToLike(e, commentId) {
    console.log('---------handleToLike', e, commentId);
    let iconEle = e.srcElement;
    // let iconEle = e.srcElement.parentElement.firstElementChild
    const { materialId } = this.$route.query;
    let likeType = commentId ? 2 : 1;
    if (iconEle.classList.contains("icon-icon-heart-d-")) {
      // iconEle.classList.remove("icon-icon-heart-d-", "icon-red");
      // iconEle.classList.add("icon-icon-heart-");
      // iconEle.nextElementSibling.innerText--;
      iconEle.previousElementSibling.style.display = 'block';
      iconEle.style.display = 'none';
      iconEle.nextElementSibling.innerText--;
      this.handleLikeArticle({
        materialId: materialId,
        materialCommentId: commentId || null,
        likeType: likeType,
        isLiked: 0
      });
    } else {
      // iconEle.classList.remove("icon-icon-heart-");
      // iconEle.classList.add("icon-icon-heart-d-", "icon-red");
      // iconEle.nextElementSibling.innerText++;
      iconEle.style.display = 'none';
      iconEle.nextElementSibling.style.display = 'block';
      iconEle.nextElementSibling.nextElementSibling.innerText++;
      this.handleLikeArticle({
        materialId: materialId,
        materialCommentId: commentId || null,
        likeType: likeType,
        isLiked: 1
      });
    }
  },
  handleSendComment () {
    console.log(`===========发表评论`);
    let replyInp = document.querySelector('#replyInput');
    // console.log(this.evaluation,this.replyName);
    // 没内容不能发评论
    if (this.evaluation == '') {
      this.$toast({
        message: '回复不能为空',
        duration: 1500
      });
      return
    }
    // 同时防止重复发送相同评论
    if (this.sendStatus) {
      this.$toast({
        message: '已经发表内容了',
        duration: 1500
      });
      return
    }
    this.sendStatus = true;
    // 发送修改评论
    this.sendComment().then(data => {
      const {userName, headImg} = data;
      console.log('===========>userName',userName);
      let placeholder = replyInp.getAttribute('placeholder');
      // 判断是回复当前文章即可当前页面中展示
      if (placeholder == '社区逢知己，不如聊一句') {
        // 把当前用户回复文章评论，前插进数组展示
        this.commentData.unshift({
          headImg: headImg, // 用户头像，后端返回获取
          commentContent: this.evaluation, // 用户回复内容
          nickName: userName,   // 用户名称，后端返回获取
          createTime: moment().format(dateFormatStr), // 创建时间
          likeNum: 0, // 点赞
        });
        this.commentTotal++;
      } else {
        console.log('======回复二级评论',this.replyindex)
        if (this.isHot) {
          console.log('===================>this.hotCommentList,this.replyindex',this.hotCommentList,this.replyindex);
          this.hotCommentList.data[this.replyindex].replyList = this.hotCommentList.data[this.replyindex].replyList ? this.hotCommentList.data[this.replyindex].replyList : [];
          this.hotCommentList.data[this.replyindex].replyList.unshift({
            headImg: headImg, // 用户头像，后端返回获取
            commentContent: this.evaluation, // 用户回复内容
            nickName: userName,   // 用户名称，后端返回获取
            createTime: moment().format(dateFormatStr), // 创建时间
            likeNum: 0, // 点赞
            replyNickName: this.replyUserName
          });
        }
        else {
          this.commentData[this.replyindex].replyList = this.commentData[this.replyindex].replyList ? this.commentData[this.replyindex].replyList : [];
          this.commentData[this.replyindex].replyList.unshift({
            headImg: headImg, // 用户头像，后端返回获取
            commentContent: this.evaluation, // 用户回复内容
            nickName: userName,   // 用户名称，后端返回获取
            createTime: moment().format(dateFormatStr), // 创建时间
            likeNum: 0, // 点赞
            replyNickName: this.replyUserName
          });
        }
        // this.commentTotal++;
      }
      this.evaluation = '';
      this.sendStatus = false;
      this.$toast({
        message: '回复成功',
        duration: 1500
      });
    }).catch(err => {
      console.log('===========err',err);
      this.sendStatus = false;
      this.$toast({
        message: '发送失败，请重新发送',
        duration: 1500
      });
    });

  },
  handleRelpy (name, materialCommentId, firstCommentId, replyindex, isHot = false) {
    console.log(replyindex,name);
    this.isHot = isHot;
    this.replyindex = replyindex;
    this.replyUserName = name;
    if (firstCommentId) {
      this.materialCommentId = materialCommentId;
      this.firstCommentId = firstCommentId;
      this.commentType = 2;
    } else {
      this.materialCommentId = materialCommentId;
      this.firstCommentId = materialCommentId;
      this.commentType = 2;
    }
    let replyInp = document.querySelector('#replyInput');
    console.log(name, this.materialCommentId, this.firstCommentId, isHot);
    name ? replyInp.setAttribute('placeholder', `回复${name}:`) : replyInp.setAttribute('placeholder', `社区逢知己，不如聊一句`);
    replyInp.focus();
    this.scrollContent();
  },
  handleChangeReply () {
    let replyInp = document.querySelector('#replyInput');
    // 判断是否切换回评论文章的状态
    if (!this.replyName) {
      // replyInp.setAttribute('placeholder', `回复${this.replyName}:`)
      if (this.evaluation == '') {
        replyInp.setAttribute('placeholder', `社区逢知己，不如聊一句`);
        this.materialCommentId = undefined;
        this.firstCommentId = undefined;
        this.commentType = 1;
      }
    }
  },
  handleCommentReply (e, id, name) {
    const { materialId } = this.$route.query;
    this.$router.push({
      path: `/wp/app/commentList/${materialId}/replyComment/${id}`,
      query: {
        materialId,
        name
      }
    });
  },
  // handleFixedView () {
  //   document.body.scrollTop = document.body.scrollHeight;
  // },
  scrollContent () {
    // document.body.scrollTop = document.body.scrollHeight;
    let fixedBottom = document.querySelector('#fixed-bottom');
    fixedBottom.scrollIntoView();
  },
  handleExp (e) {
    console.log(e.srcElement.parentElement.parentElement.children);
    let arrElement = e.srcElement.parentElement.parentElement.children;
    for (let i = 0; i < arrElement.length; i++) {
      arrElement[i].style.display = 'block';
    }
    document.querySelector("#expend-all").style.display = 'none';
  }
};



// WEBPACK FOOTER //
// ./src/module/app/commentPage/action.js